import styled from 'styled-components/macro';

export const ScWrapper = styled.div`
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
`;
